<div class="product-card-group-item">
  <mat-checkbox
    class="product-card-group-item-checkbox"
    [checked]="isSelected()"
    (change)="handleUpdateChecked($event)"
  />
  <div class="product-card-group-item-img-wrapper">
    <img
      class="product-card-group-item-img"
      alt=""
      [src]="photo()"
    >
  </div>

  <div class="product-card-group-item-title">
    {{ wildberriesProductCardData().title || 'Название не задано' }}
  </div>
  <div class="product-card-group-item-params">
    @for (param of displayProductItemData; track $index) {
      <div class="product-card-group-item-param">
        <div class="product-card-group-item-param-label">
          {{ param.label }}:
        </div>
        <div class="product-card-group-item-param-value">
          {{ getParamData(param.fieldName) }}
        </div>
      </div>
    }
  </div>
  <div class="buttons-container">
    <a
      mat-button
      class="save-button"
      target="_blank"
      [href]="wildberriesProductCardData().linkToMarketplace"
    >
      <mat-icon>
        share
      </mat-icon>
      Открыть
    </a>
  </div>
</div>
